export const MAX_FLOATING_HEIGHT = 400;
export const MAX_FLOATING_WIDTH = 300;
